import React, {Fragment, Component} from 'react';
import cx from 'classnames';
import {connect} from 'react-redux';
import {
    getActiveClientAccount,
} from '../../store/auth'
import {
    setSidebarToggleMobile
} from '../../reducers/ThemeOptions';
import jobstatsLogo from '../../assets/jobelephant/images/jobstats_logo.png';



class HeaderJobStats extends Component {

    toggleSidebarMobile = () => {
        let {sidebarToggleMobile, setSidebarToggleMobile} = this.props;
        setSidebarToggleMobile(!sidebarToggleMobile);
    }

    render() {
        let {
            clientAccountName,
            headerShadow,
            headerBgTransparent,
            sidebarToggleMobile
        } = this.props;

        return (
            <Fragment>
                <div className={cx("app-header", {'app-header--shadow': headerShadow, 'app-header--opacity-bg': headerBgTransparent})}>
                <div className="app-header--pane">
                    
                    <button className={cx("navbar-toggler hamburger hamburger--elastic toggle-mobile-sidebar-btn", {'is-active': sidebarToggleMobile})} onClick={this.toggleSidebarMobile}>
                        <span className="hamburger-box">
                            <span className="hamburger-inner"/>
                        </span>
                    </button>
                    
                    <div className="d-none d-lg-block je-header-page-title mb-2">
                        <div className="je-header-jobstats-page-logo">
                            <img alt="Job Stats" src={jobstatsLogo}/>
                            <div className="je-header-jobstats-page-title">
                                Recruitment Advertising Analytics
                            </div>
                        </div>
                    </div>
                    
                    <div className="d-block d-lg-none je-header-page-title mb-2">
                        <div className=" text-center">
                            <div className="float-left mt-1 je-header-campaign-detail-page-title">
                                <div className="je-header-jobstats-page-logo">
                                    <img alt="Job Stats" src={jobstatsLogo}/>
                                </div>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>

                </div>
                <div className="app-header--pane">
                        
                </div>
            </div>
            </Fragment>
    );
    }
}

const mapStateToProps = state => ({
    headerShadow: state.ThemeOptions.headerShadow,
    headerBgTransparent: state.ThemeOptions.headerBgTransparent,
    sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile,
    clientAccountName:getActiveClientAccount(state).name || "",

});

const mapDispatchToProps = dispatch => ({

    setSidebarToggleMobile: enable => dispatch(setSidebarToggleMobile(enable)),

});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderJobStats);
